import React, { useEffect, useState, Component, useRef  } from 'react';
import { useParams, Link } from "react-router-dom";

import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToHTML } from 'draft-convert';
import { stateFromHTML } from 'draft-js-import-html'
import images from '../../../helpers/images';
import appConfig from '../../../config/env';
import helpers from '../../../helpers/helpers';
import { httpRequest, httpFormRequest } from '../../../helpers/httpService';
import store from '../../../helpers/store';
import Swal from 'sweetalert2';
import InputText from '../../elements/InputText';
import InputTextArea from '../../elements/InputTextArea';
import DropDownSelection from '../../elements/DropDownSelection';
import Radio from '../../elements/Radio';
import InputFile from '../../elements/InputFile';
import Checkbox from '../../elements/Checkbox';
import Loader from '../../parts/Loader';
import InputNumber from '../../elements/InputNumber';
import RenderErrors from '../../elements/RenderErrors';

import Table from 'react-bootstrap/Table';
import { compareByFieldSpec } from '@fullcalendar/react';

 
function EventForm (){
    const $ = window.$;
    let { event_id } = useParams();
    const api_url = appConfig.apiUrl;
    const [event_data, setEvent] = useState(store.event_data);
    const [field_data, setFields] = useState(store.event_fields) //Event List Field
    const [option_data, setOptions] = useState([])
    const [restriction_code_data, setRestrictionCodes] = useState([]) //store.event_restriction_codes
    const [data_loaded, setDataLoaded] = useState(0);

    const [all_day_event, setAllDayEvent] = useState(0)
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(1);

    const [category_list, setCategories] = useState([]);
    const [type_list, setTypes] = useState([]);
    const [custom_field_list, setCustomFields] = useState([]);

    const [new_event_field, setEventFields] = useState({
        field_id: "",
        is_required: 0
    })


    //////////////////////
    const [editorState, setEditorState] = useState(
      //EditorState.createWithContent(stateFromHTML(htmls))
      () => EditorState.createEmpty(),
    );
    const  [convertedContent, setConvertedContent] = useState('');
    /////////////////////////

    useEffect(() => {
        if(event_id){
          getEvent()
        }else{
          setLoading(0)
        }

        getCategories()
        getTypes()
        getCustomFields()
        window.scrollTo(0,0);

        helpers.initFileDragDrop();
    }, []);

    useEffect(() => {
        // let new_state = { details : convertedContent }

        // setEvent({...event_data, ...new_state});
    }, [convertedContent]);

    useEffect(() => {

        if(event_data.start_time == '00:00:00' && event_data.end_time == '23:59:59'){
          setAllDayEvent(1)
        }

    }, [event_data]);

  function getEvent() {
      const url = api_url + '/admin/events/'+event_id;

      httpRequest(url, "GET",  {}, true)
          .then((res) => {
            let data = {...res}
            data.category_id = res.category_id.id
            data.type_id  = res.type_id.id
            delete data.id;
            delete data.created_at;
            delete data.created_by;
            delete data.fields;
            delete data.options;
            delete data.registration_table_name;
            delete data.restrictions;
            delete data.slug;
            delete data.updated_at;
            delete data.updated_by;
            delete data.data_status;

            setEvent({...event_data, ...data});

            let fields = res.fields.map((item) => ({
                id: item.id, 
                field_id: item.field_id, 
                is_required: item.is_required   
              }));

            // let options = res.options.map((item) => ({
            //     id: item.id, 
            //     option: item.option_name, 
            //     value: item.option_value   
            //   }));

            let options = {}

            Object.entries(res.options).map(([key, data]) => {
              let value = data;

              if(typeof data === 'object'){
                value = Object.entries(data).map(([key, data]) => {
                    return data.id;
                })
              }

              options[key] = value;
            });

            setFields(fields)
            setOptions(options)

            if(Object.entries(res.restriction_codes).length){
                setRestrictionCodes(res.restriction_codes)
            }

            
            setEditorState( EditorState.createWithContent(stateFromHTML(res.details)));
            setLoading(0)
            setDataLoaded(1)
          })
          .catch((err) => {
              setLoading(0)
              setDataLoaded(0)

              Swal.fire({
                  title: "Error!",
                  text: err.message,
                  icon: "error",
                  confirmButtonText: "OK",
              });
          });
  }

  function getCategories() {
      const url = api_url + '/admin/categories';

      httpRequest(url, "GET", {}, true)
          .then((res) => {
              setCategories(res);
          })
          .catch((err) => {
              setLoading(0)

              Swal.fire({
                  title: "Error!",
                  text: err.message,
                  icon: "error",
                  confirmButtonText: "OK",
              });
          }); 
  }

  function getTypes() {
      const url = api_url + '/admin/types';

      httpRequest(url, "GET", {}, true)
          .then((res) => {
              setTypes(res);
          })
          .catch((err) => {
              setLoading(0)

              Swal.fire({
                  title: "Error!",
                  text: err.message,
                  icon: "error",
                  confirmButtonText: "OK",
              });
          }); 
  }

  function getCustomFields() {
      const url = api_url + '/admin/fields';

      httpRequest(url, "GET", {}, true)
          .then((res) => {
              setCustomFields(res);
          })
          .catch((err) => {
              setLoading(0)

              Swal.fire({
                  title: "Error!",
                  text: err.message,
                  icon: "error",
                  confirmButtonText: "OK",
              });
          }); 
  }

  function resetInputs(){
      setEvent(store.event_data);
      setFields(store.event_fields) //Event List Field
      setOptions([])
      setRestrictionCodes(store.event_restriction_codes)
      setAllDayEvent(0)
  }

  function inputChange(e) {
    let { value, name } = e.target;

    if (e.target.type === "checkbox") {
        if (e.target.checked) {
            value = 1;
        } else {
            value = 0;
        }
    }
    else if (e.target.type === "file") {
      value = e.target.files[0]
    }

    let new_state = { [name]: value }

    setEvent({...event_data, ...new_state});
  }

  function allDayEvent(e) {
    let { value, name } = e.target;

    if (e.target.type === "checkbox") {
        if (e.target.checked) {
            value = 1;
        } else {
            value = 0;
        }
    }

    setAllDayEvent(value)
  }

  
  const handleEditorChange = (state) => {
    setEditorState(state);
    //convertContentToHTML();
    
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    let new_state = { details : currentContentAsHTML }
    setEvent({...event_data, ...new_state});
  }
  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(currentContentAsHTML);
  }

  
  /*** Options */
  

  function inputOption(e) {
    let { value, name } = e.target;
    //let updated_options = [...option_data];
    let updated_options = option_data[name]

    if(typeof Number(value) === 'number'){
        value = Number(value)
    }
    
    if(isOptionExist(name, value)){
      //const index = getOptionIndex(name, value)
      const index = updated_options.indexOf(value);

      if (e.target.type === "checkbox") {
        if (!e.target.checked) {
          //Remove Data
          updated_options.splice(index, 1);
        }
      }

    }else{
      // updated_options.push({
      //     id: 0,
      //     option: name,
      //     value: value,
      // });

      updated_options.push(value)
    }

    //setOptions(updated_options)
    setOptions({...option_data, [name]: updated_options})
  }

  let payment_method_otions = [];
  payment_method_otions =  Object.entries(store.payment_methods).map(([key, data]) => {
    return <div key={key} className="form-check form-check-inline">
              <Checkbox
                  id={data.id}
                  name="payment_method"
                  value={data.id}
                  label={data.name}
                  labelClass="form-check-label"
                  tagClass="form-check-input radio-box"
                  onChange={inputOption}
                  checked = {isOptionExist('payment_method', data.id)}
              />
          </div>
  })

  // function getOptionIndex(name, value){

  //   const result = Object.values(option_data).findIndex(item => item.option === name && item.value == value);

  //   return result

  // }

  function isOptionExist(name, value){
    //const result = Object.values(option_data).filter(item => item.option === name && item.value == value).length;
    //return result

    if(option_data.hasOwnProperty(name)){
        if(typeof option_data[name] === 'object'){
            if(option_data[name].includes(value)) return true;
        }
        else{
            if(option_data[name] == value) return true;
        }
    }

    return;
  }

  /***** End Options *****/

  
  /** Custom Fields **/

    function addEventField(){

      if(!new_event_field.field_id){
        Swal.fire({
            title: "Error!",
            text: 'Please select custom field',
            icon: "error",
            confirmButtonText: "OK",
        });
        return;
      }

      let updated_data = [...field_data];

      updated_data.push({
        id: 0,
        field_id: new_event_field.field_id,
        is_required: new_event_field.is_required,
      });

      setFields(updated_data)
      setEventFields({
        field_id: "",
        is_required: 0
      })
    }

    function removeEventField(e, index){
      let updated_data = [...field_data];

      updated_data.splice(index, 1);

      setFields(updated_data)
    }

    function updateEventField(e, index){

      let { value, name } = e.target;

      if (e.target.type === "checkbox") {
        if (e.target.checked) {
            value = 1;
        } else {
            value = 0;
        }
      }

      let updated_data = [...field_data];
      updated_data[index][name] = value;
      setFields(updated_data)
    }

    function inputEventField(e){

      let { value, name } = e.target;

      if (e.target.type === "checkbox") {
        if (e.target.checked) {
            value = 1;
        } else {
            value = 0;
        }
      }

      let new_state = { [name]: parseInt(value) }

      
      if(name==='field_id'){
        new_state.is_required = 0;
      }

      setEventFields({...new_event_field, ...new_state});

    }

    function getFieldData(field_id, target_data){
      const result = Object.values(custom_field_list).find(item => item.id === field_id);

      var data = '';

      for (var key in result) {
        if(key==target_data){
          data = result[key];
        }
      }

      return data;
    }

  
    function hasFieldData(field_id){
      return Object.values(field_data).filter(item => item.field_id === field_id).length;
    }

    function changeOrder(old_index, new_index){

        let updated_data = [...field_data];

        updated_data.splice(new_index, 0, updated_data.splice(old_index, 1)[0]);
        setFields(updated_data)
    }

    function customFieldTable() {
      let items = [];

      items = Object.entries(field_data).map(([index, data]) => {
        const total = Object.keys(field_data).length - 1;
        return <tr key={index}>
                  <td className='text-center'>
                      {
                        index > 0 ? <button type="button" className="btn btn-sm btn-light me-2" onClick={(e)=>changeOrder(index, Number(index)-1)}><i class="fas fa-chevron-up"></i></button> : ""
                      }

                      {
                        index < total ? <button type="button" className="btn btn-sm btn-light" onClick={(e)=>changeOrder(index, Number(index)+1)}><i class="fas fa-chevron-down"></i></button> : ""
                      }
                      
                  </td>
                  <td>{getFieldData(data.field_id, 'field_label')}</td>
                  <td>{getFieldData(data.field_id, 'field_type')}</td>
                  <td>
                    {!getFieldData(data.field_id, 'is_required') ?
                      <Checkbox
                          id={'is_required_'+index}
                          name="is_required"
                          value={data.is_required}
                          labelClass="form-check-label"
                          tagClass="form-check-input radio-box"
                          onChange={(e) => updateEventField(e, index)}
                          checked = {data.is_required}
                      />
                      : 'Default'
                    }
                  </td>
                  <td className='text-center'>
                    
                    {!getFieldData(data.field_id, 'is_required') &&
                    <button type='button' className='btn btn-danger btn-sm' onClick={(e)=>removeEventField(e, index)}><i className="fas fa-minus"></i></button>
                    }
                  </td>
              </tr>
      })

      //Avaiable custom fields
      const available_fields = Object.values(custom_field_list).filter(item => !hasFieldData(item.id))
      
      return (
        <Table striped bordered hover responsive size="md">
          <thead>
              <tr>
                  <th width="100">Order</th>
                  <th>Field</th>
                  <th>Type</th>
                  <th width="50">Required</th>
                  <th width="50">Action</th>
              </tr>
          </thead>
          <tbody>
              { items }
              <tr>
                  <td colSpan={2}>
                  <DropDownSelection
                      tagClass="form-select mb-0"
                      name='field_id' 
                      placeholder='Select Field'
                      value={new_event_field.field_id}
                      onChange={inputEventField}
                      optionList={available_fields}
                      optionProps ={{value:'id', label:'field_label'}}
                  />

                  </td>
                  <td>{getFieldData(new_event_field.field_id, 'field_type')}</td>
                  <td>
                    <Checkbox
                        id='is_required'
                        name="is_required"
                        value={new_event_field.is_required}
                        labelClass="form-check-label"
                        tagClass="form-check-input radio-box"
                        onChange={inputEventField}
                        checked = {new_event_field.is_required}
                    />
                  </td>
                  <td className='text-center'><button type='button' className='btn btn-success btn-sm' onClick={addEventField}><i className="fas fa-plus"></i></button></td>
              </tr>
          </tbody>
        </Table>
      );
    }

    /***** */


    // Retsriction code
    function inputRestrictionCode(e, index){
      const {name, value} = e.target;

      const updated_data = [...restriction_code_data];
      updated_data[index][name] = value;
      setRestrictionCodes(updated_data)
    }

    function addRestrictionCode(e, index){
      const updated_data = [...restriction_code_data];

      updated_data.push({
          id: 0,
          name: "",
          code: "",
          max_limit: ""
      });

      setRestrictionCodes(updated_data)
    }

    function removeRestrictionCode(e, index){
      const updated_data = [...restriction_code_data];

      updated_data.splice(index, 1);
      setRestrictionCodes(updated_data)
    }

    function restrictionCodesTable() {
      let items = [];
      const total = Object.entries(restriction_code_data).length;
      let counter = 0;
      items = Object.entries(restriction_code_data).map(([index, data]) => {
        {counter++}
        return <tr key={index}>
                  <td>
                      <InputText
                          id="name" 
                          name="name" 
                          value={data.name}
                          tagClass="form-control mb-0"
                          onChange={(e) => inputRestrictionCode(e, index)}
                          placeholder="Name"
                          type="text"
                      />  
                  </td>
                  <td>
                      <InputText
                          id="code" 
                          name="code" 
                          value={data.code}
                          tagClass="form-control mb-0"
                          onChange={(e) => inputRestrictionCode(e, index)}
                          placeholder="Code"
                          type="text"
                      /> 
                  </td>
                  <td maxwidth="100">
                      <InputNumber
                          id="max_limit" 
                          name="max_limit" 
                          value={data.max_limit}
                          tagClass="form-control mb-0"
                          onChange={(e) => inputRestrictionCode(e, index)}
                          placeholder="Max no. of usage. Put 0 for non limit."
                      /> 
                  </td>
                  <td className='text-center'>
                    
                    {!getFieldData(data.id, 'is_required') &&
                    <button type='button' className='btn btn-danger btn-sm' onClick={(e)=>removeRestrictionCode(e, index)}><i className="fas fa-minus"></i></button>
                    }

                    {/* {
                      counter === total && <button type='button' className='btn btn-success btn-sm ms-3' onClick={addRestrictionCode}><i className="fas fa-plus"></i></button>
                    } */}
                  </td>
              </tr>
      })
      
      return (
        <Table striped bordered hover responsive size="sm">
          <thead>
              <tr>
                  <th className='text-center'>Name</th>
                  <th className='text-center'>Code</th>
                  <th className='text-center'>Max</th>
                  <th className='text-center'>Action <button type='button' className='btn btn-success btn-sm ms-3' onClick={addRestrictionCode}><i className="fas fa-plus"></i></button></th>
              </tr>
          </thead>
          <tbody>
              { items }
          </tbody>
        </Table>
      );
    }

    function getFormData(status = 'draft'){
      let form_data = new FormData();

      for(var key in event_data) {

          form_data.append(key, event_data[key]);

          if(key == 'image_banner'){
              form_data.set('image_banner', event_data['image_banner_file']);
              form_data.delete('image_banner_file');
          }
          else if(key == 'image_thumbnail'){
              form_data.set('image_thumbnail', event_data['image_thumbnail_file']);
              form_data.delete('image_thumbnail_file');
          }
          else if(key == 'image_email'){
              form_data.set('image_email', event_data['image_email_file']);
              form_data.delete('image_email_file');
          }
      }

      if(Object.entries(option_data).length > 0){
        form_data.append('options', JSON.stringify(option_data));
      }

      if(Object.entries(restriction_code_data).length > 0){
        form_data.append('restriction_codes', JSON.stringify(restriction_code_data));
      }

      form_data.append('fields', JSON.stringify(field_data));
      form_data.append('status', status);

      return form_data
    }


    function submit(e, status){
      e.preventDefault();
      let url = ''
      if(event_id && data_loaded){
          url = api_url + '/admin/events/'+event_id;
      }else{
          url = api_url + '/admin/events';
      }

      let form_data = getFormData(status);
      const formDataObj = Object.fromEntries(form_data);

      setLoading(1);

      httpFormRequest(url, "POST", {
          postdata: form_data,
      }, true)
      .then((res) => {
          setLoading(0);
          
          if(res.status == 'success'){
              Swal.fire({
                  title: 'Success!',
                  text: res.message,
                  icon: 'success',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false
              }).then((result) => {
                  if (result.isConfirmed) {
                      window.location.reload(false)
                  }
              })
          }

          //window.location.reload(false);
          //resetInputs();
      })
      .catch((err) => {
          setLoading(0);

          if(err.data){
              setErrors( err.data );
              err.message = "Please check your entry";

              // if(err.data.captcha){
              //     err.message = err.data.captcha[0];
              // }
          }else{
            setErrors([])
          }

          Swal.fire({
              title: 'Error!',
              text: err.message,
              icon: 'error',
              confirmButtonText: 'OK'
          });
      });

    }

    return (
      
    <section className="faith py-5">

        <div className="container basic-base" style={{position: 'relative'}}>
            <Loader isLoading={loading}/>

              <div className="row col-md-12 col-lg-12 col-xl-12">

                {/* Event Info */}
                <div className="col-12">
                  <div className="container">
                    <div className="row mb-5">
                      <div className="col-1">
                        <img src={images.basicInfo} alt="basicInfo" />
                      </div>
                      <div className="col-11 px-5">
                          {data_loaded ? <div className='mb-3'>{helpers.displayStatusBadge(event_data.status)}</div> : <></>}

                          <h1 className="add-event-title ">Basic Information</h1>
                          <p className="add-event-details">While the country is confronted by possibly the most
                            massive and challenging threat brought by the COVID-19 pandemic, Filipinos can be
                            affected not just physically but ...</p>
                        
                          <div className='mb-3'>
                              <InputText
                                  id="title" 
                                  name="title" 
                                  value={event_data.title}   
                                  label="Event Title*"
                                  tagClass="form-control"
                                  onChange={inputChange}
                                  placeholder="Be clear and descriptive"
                                  type="text"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="title" 
                                  className="text-danger fs-7"
                              />
                          </div>

                        
                          <div className='mb-3'>
                              <InputText
                                  id="organizer" 
                                  name="organizer" 
                                  value={event_data.organizer}   
                                  label="Organizer*"
                                  tagClass="form-control"
                                  onChange={inputChange}
                                  placeholder="Unnamed organizer"
                                  type="text"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="organizer" 
                                  className="text-danger fs-7"
                              />

                              <p className="add-event-details">This profile describes a unique organizer and shows all
                                of the events on one page. <a href="#" className="organizer-info-link">View
                                  Organizer Info.</a></p>
                          </div>

                          <div className='mb-3'>
                              <DropDownSelection
                                  tagClass="form-select"
                                  id="category_id"
                                  name='category_id' 
                                  placeholder='Select Category'
                                  label="Category*"
                                  value={event_data.category_id}  
                                  onChange={inputChange}
                                  optionList={category_list}
                                  optionProps ={{value:'id', label:'category_name'}}
                                  origin="category"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="category_id" 
                                  className="text-danger fs-7"
                              />
                          </div>

                          <div>

                              <DropDownSelection
                                  tagClass="form-select"
                                  id="type_id"
                                  name='type_id' 
                                  placeholder='Select Type'
                                  label="Types*"
                                  value={event_data.type_id}  
                                  onChange={inputChange}
                                  optionList={type_list}
                                  optionProps ={{value:'id', label:'type_name'}}
                                  origin="type"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="type_id" 
                                  className="text-danger fs-7"
                              />
                          </div>
                      </div>
                    </div>
                    {/* Location */}
                    <div className="row col-md-12 col-lg-12 col-xl-12 mb-5">
                      <div className="col-sm-1">
                        <img src={images.location} alt="location" />
                      </div>
                      <div className="col-sm-11 px-5">
                        <h1 className="add-event-title ">Location</h1>
                        <p className="add-event-details">
                          Help people in the area discover your event and let attendees know where to show up.
                        </p>

                        <div className="payment-method-wrap">
                            <Radio
                                id="physical"
                                name="venue_type"
                                value="physical"
                                label='Physical'
                                labelClass={(event_data.venue_type == 'physical') ? 'item btn-payment checked' : 'item btn-payment'}
                                onChange={inputChange}
                                checked = {event_data.venue_type == 'physical'}
                            />

                            <Radio
                                id="online"
                                name="venue_type"
                                value="virtual"
                                label='Online Event'
                                labelClass={(event_data.venue_type == 'virtual') ? 'item btn-payment checked' : 'item btn-payment'}
                                onChange={inputChange}
                                checked = {event_data.venue_type == 'virtual'}
                            />
                        </div>

                        {/* Physical Venue */}
                        { event_data.venue_type == 'physical' &&
                            <>
                            <InputTextArea
                                id="address" 
                                name="address" 
                                value={event_data.address}    
                                label="Complete Address *" 
                                tagClass="form-control mb-0"
                                onChange={inputChange}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="address" 
                                className="text-danger fs-7"
                            />

                            {/* <label>Venue Location</label>
                            <div className="input-group">
                              <input className="form-control border-end-0 border-0" type="search" defaultValue id="example-search-input" placeholder="Search for" />
                              <span className="input-group-append">
                                <button className="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border-0 ms-n5" type="button">
                                  <i className="fa fa-search" />
                                </button>
                              </span>
                            </div>

                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15442.254899664471!2d121.0630867!3d14.6239114!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x349c8a93e3c80fca!2sThinkBIT%20Solutions!5e0!3m2!1sen!2sph!4v1658408917990!5m2!1sen!2sph" width="100%" height={400} style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> */}
                            </>
                        }
                        {/* Online */}

                        { event_data.venue_type == 'virtual' &&
                            <>
                            <div className='mb-3'>
                                <InputText
                                    id="online_link" 
                                    name="online_link" 
                                    value={event_data.online_link}   
                                    label="Online Link *"
                                    tagClass="form-control"
                                    onChange={inputChange}
                                    placeholder="Zoom, Skype, WebEx, Google Meet, Microsoft Teams and etc."
                                    type="text"
                                />
                                <RenderErrors 
                                    errors={errors} 
                                    name="online_link" 
                                    className="text-danger fs-7"
                                />
                            </div>

                            <div className='mb-3'>
                                <InputText
                                    id="online_link_password" 
                                    name="online_link_password" 
                                    value={event_data.online_link_password}   
                                    label="Password"
                                    tagClass="form-control"
                                    onChange={inputChange}
                                    type="text"
                                />
                                <RenderErrors 
                                    errors={errors} 
                                    name="online_link_password" 
                                    className="text-danger fs-7"
                                />
                            </div>
                            </>
                        }

                      </div>
                    </div>
                    {/* Date and Time */}
                    <div className="row col-md-12 col-lg-12 col-xl-12 mb-5">
                      <div className="col-sm-1">
                        <img src={images.calendar} alt="location" />
                      </div>
                      <div className="col-11 px-5">
                        <h1 className="add-event-title ">Date and Time</h1>
                        <p className="add-event-details">
                          Tell event-goers when your events starts and ends so they can make plans to attend.
                        </p>

                        <p>Single event happens once and can last multiple days</p>

                          <div className="row">
                              <div className="col-md-6 mb-3">
                                  <InputText
                                      id="start_date" 
                                      name="start_date" 
                                      value={event_data.start_date}   
                                      label="Event Starts *"
                                      tagClass="form-control"
                                      onChange={inputChange}
                                      type="date"
                                  />
                                  <RenderErrors 
                                      errors={errors} 
                                      name="start_date" 
                                      className="text-danger fs-7"
                                  />
                              </div>
                              <div className="col-md-6 mb-3">
                                  <InputText
                                      id="end_date" 
                                      name="end_date" 
                                      value={event_data.end_date}   
                                      label="Event Ends *"
                                      tagClass="form-control"
                                      onChange={inputChange}
                                      type="date"
                                  />
                                  <RenderErrors 
                                      errors={errors} 
                                      name="end_date" 
                                      className="text-danger fs-7"
                                  />
                              </div>
                          </div>
                          <div className="form-check mb-3">
                            <Checkbox
                                id="all_day"
                                name="all_day"
                                value="physical"
                                label='All Day Event'
                                labelClass="form-check-label"
                                tagClass="form-check-input radio-box"
                                onChange={allDayEvent}
                                checked = {all_day_event}
                            />
                          </div>

                          { !all_day_event &&
                          <div className="row">
                              <div className="col-md-6 mb-3">
                                  <InputText
                                      id="start_time" 
                                      name="start_time" 
                                      value={event_data.start_time}   
                                      label="Start Time"
                                      tagClass="form-control"
                                      onChange={inputChange}
                                      type="time"
                                  />
                                  <RenderErrors 
                                      errors={errors} 
                                      name="start_time" 
                                      className="text-danger fs-7"
                                  />
                              </div>
                              <div className="col-md-6 mb-3">
                                  <InputText
                                      id="end_time" 
                                      name="end_time" 
                                      value={event_data.end_time}   
                                      label="End Time"
                                      tagClass="form-control"
                                      onChange={inputChange}
                                      type="time"
                                  />
                                  <RenderErrors 
                                      errors={errors} 
                                      name="end_time" 
                                      className="text-danger fs-7"
                                  />
                              </div>
                          </div>
                          }

                          <div>
                              <DropDownSelection
                                  tagClass="form-select"
                                  name='time_zone' 
                                  placeholder='Select Time Zone'
                                  label="Time Zone*"
                                  value={event_data.time_zone}  
                                  onChange={inputChange}
                                  optionList={store.timezones}
                                  optionProps ={{value:'value', label:'text'}}
                                  origin="status"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="time_zone" 
                                  className="text-danger fs-7"
                              />
                          </div>
                      </div>
                    </div>
                    {/*Banner*/}
                    <div className="row col-md-12 col-lg-12 col-xl-12 mb-5">
                      <div className="col-1">
                        <img src={images.calendar} alt="calendar" />
                      </div>
                      <div className="col-11 px-5">
                        <h1 className="add-event-title ">Main Event Image</h1>
                        <h2 className="banner-subtitle">Main Banner Image</h2>
                        <p className="add-event-details">
                          This is the first image attendees will see at the top of your listing. Use a high
                          quality image: 2160 x 1080 px (2:1 ratio)
                          <br /><a href="#" className="organizer-info-link">Learn more
                          </a>
                        </p>

                        <div className='mb-3'>
                            <div className="upload-banner-wrap">
                                <div className="item">
                                    <div className={(event_data.image_banner) ? "drag-drop-wrap has-item mb-0": "drag-drop-wrap mb-0"}>
                                        <InputFile
                                            id="main-img" 
                                            name="image_banner_file" 
                                            tagClass="event-banner-img"
                                            onChange={inputChange}
                                            type="file"
                                            accept="image/*"
                                        />
                                        
                                        <div>
                                            <div className="empty" style={{display: (event_data.image_banner) ? "none": "block"}}>
                                                <img src={images.icoImage} alt="icon" />
                                                <span>Drag and drop or click here to upload your photo</span>
                                                <span className="text-primary">JPEG, PNG, GIF 5 MB Only.</span>
                                            </div>
                                            <div className="image-preview" style={{display: (event_data.image_banner) ? "block": "none"}}>
                                                <img className="banner" id="img-main-img" src={helpers.getFileURL(event_data.image_banner)} alt="banner" />
                                            </div>
                                        </div>
                                    </div>{/* /drag-drop-wrap */}
                                </div>
                            </div>

                            <RenderErrors 
                                      errors={errors} 
                                      name="image_banner" 
                                      className="text-danger fs-7"
                                  />
                        </div>

                        <h2 className="banner-subtitle">Thumbnail Image</h2>
                        <p className="add-event-details">
                          This is the first image attendees will see at the top of your listing. Use a high
                          quality image: 2160 x 1080 px (2:1 ratio)
                          <br /><a href="#" className="organizer-info-link">Learn more
                          </a>
                        </p>
                        <div className='mb-3'>
                            <div className="upload-banner-wrap">
                              <div className="item">
                                <div className={(event_data.image_thumbnail) ? "drag-drop-wrap has-item mb-0": "drag-drop-wrap mb-0"}>
                                  <InputFile
                                      id="thumbnail-img" 
                                      name="image_thumbnail_file" 
                                      tagClass="event-banner-img"
                                      onChange={inputChange}
                                      type="file"
                                      accept="image/*"
                                  />

                                  <div>
                                    <div className="empty" style={{display: (event_data.image_thumbnail) ? "none": "block"}}>
                                      <img src={images.icoImage} alt="icon" />
                                      <span>Drag and drop or click here to upload your photo</span>
                                      <span className="text-primary">JPEG, PNG, GIF 5 MB Only.</span>
                                    </div>
                                    <div className="image-preview" style={{display: (event_data.image_thumbnail) ? "block": "none"}}>
                                      <img className="banner" id="img-thumbnail-img" src={helpers.getFileURL(event_data.image_thumbnail)} alt="banner" />
                                    </div>
                                  </div>
                                </div>{/* /drag-drop-wrap */}
                              </div>
                            </div>

                            <RenderErrors 
                                errors={errors} 
                                name="image_thumbnail" 
                                className="text-danger fs-7"
                            />
                        </div>
                        <h2 className="banner-subtitle">Email Banner Image</h2>
                        <p className="add-event-details">
                          This is the first image attendees will see at the top of your listing. Use a high
                          quality image: 2160 x 1080 px (2:1 ratio)
                          <br /><a href="#" className="organizer-info-link">Learn more
                          </a>
                        </p>

                        <div className='mb-3'>
                            <div className="upload-banner-wrap">
                              <div className="item">
                                <div className={(event_data.image_email) ? "drag-drop-wrap has-item mb-0": "drag-drop-wrap mb-0"}>
                                  {/* <input type="file" className="event-banner-img" id="email-img" accept="image/*" /> */}
                                  <InputFile
                                      id="email-img" 
                                      name="image_email_file" 
                                      tagClass="event-banner-img"
                                      onChange={inputChange}
                                      type="file"
                                      accept="image/*"
                                  />

                                  <div>
                                    <div className="empty" style={{display: (event_data.image_email) ? "none": "block"}}>
                                      <img src={images.icoImage} alt="icon" />
                                      <span>Drag and drop or click here to upload your photo</span>
                                      <span className="text-primary">JPEG, PNG, GIF 5 MB Only.</span>
                                    </div>
                                    <div className="image-preview" style={{display: (event_data.image_email) ? "block": "none"}}>
                                      <img className="banner" id="img-email-img" src={helpers.getFileURL(event_data.image_email)} alt="banner" />
                                    </div>
                                  </div>
                                </div>{/* /drag-drop-wrap */}
                              </div>
                            </div>

                            <RenderErrors 
                                errors={errors} 
                                name="image_email" 
                                className="text-danger fs-7"
                            />
                        </div>
                      </div>
                    </div>
                    {/* Description x Add tickets */}
                    <div className="row col-md-12 col-lg-12 col-xl-12mb-5">
                      <div className="col-1">
                        <img src={images.location} alt="location" />
                      </div>
                      <div className="col-11 px-5">
                        <h1 className="add-event-title ">Description</h1>

                        <InputTextArea
                            id="summary" 
                            name="summary" 
                            label="Summary*"
                            value={event_data.summary}  
                            tagClass="form-control mb-3"
                            onChange={inputChange}
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="summary" 
                            className="text-danger fs-7"
                        />
                  
                        <label>Details*</label>
                        <Editor
                          //defaultContentState={contentState}
                          editorState={editorState}
                          onEditorStateChange={handleEditorChange}
                          wrapperClassName="wrapper-class"
                          editorClassName="editor-class"
                          toolbarClassName="toolbar-class"
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="details" 
                            className="text-danger fs-7"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Ticket */}
                <div className="col-12">
                    <hr />
                    <div className="container">
                      <div className="row">
                        <div className="col-6">
                          <h1 className="add-tickets">Registration</h1>
                        </div>
                        <div className="col-6 mt-3">
                          <a href="#" className="organizer-info-link d-flex justify-content-end">Learn more
                          </a>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                          <div className="col-md-12 d-flex justify-content-center">
                              <div className="payment-method-wrap">
                                  <Radio
                                      id="paid"
                                      name="registration_type"
                                      value="paid"
                                      label='Paid'
                                      labelClass={(event_data.registration_type == 'paid') ? 'item btn-payment checked' : 'item btn-payment'}
                                      onChange={inputChange}
                                      checked = {event_data.registration_type == 'paid'}
                                  />

                                  <Radio
                                      id="free"
                                      name="registration_type"
                                      value="free"
                                      label='Free'
                                      labelClass={(event_data.registration_type == 'free') ? 'item btn-payment checked' : 'item btn-payment'}
                                      onChange={inputChange}
                                      checked = {event_data.registration_type == 'free'}
                                  />
                              </div>
                          </div>
                          
                          <div className="col-md-6 mb-3">
                              <InputNumber
                                  id="participants_number" 
                                  name="participants_number" 
                                  value={event_data.participants_number}   
                                  label="Number of Participants*"
                                  tagClass="form-control"
                                  onChange={inputChange}
                                  placeholder="Number of Participants"
                                  min="1"
                                  max="1000"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="participants_number" 
                                  className="text-danger fs-7"
                              />
                          </div>

                          { event_data.registration_type == 'paid' &&
                              <div className="col-md-6 mb-3">
                                  <InputNumber
                                      id="registration_price" 
                                      name="registration_price" 
                                      value={event_data.registration_price}   
                                      label="Ticket Price (PHP)*"
                                      tagClass="form-control"
                                      onChange={inputChange}
                                      placeholder="PHP 0.00"
                                      min="0"
                                      max="9999999"
                                  />
                                  <RenderErrors 
                                      errors={errors} 
                                      name="registration_price" 
                                      className="text-danger fs-7"
                                  />
                              </div>
                          }
                      </div>
                      <div className="row">
                          <div className="col-md-6 mb-3">
                              <InputNumber
                                  id="minimum_donation" 
                                  name="minimum_donation" 
                                  value={event_data.minimum_donation}   
                                  label="Minimum Donation Amount (PHP)"
                                  tagClass="form-control"
                                  onChange={inputChange}
                                  placeholder="PHP 0.00"
                                  min="1"
                                  max="9999999"
                              />
                              <RenderErrors 
                                  errors={errors} 
                                  name="minimum_donation" 
                                  className="text-danger fs-7"
                              />
                            </div>
                            <div className="col-md-12 mb-3">

                              <div className="form-group mt-4 mb-2">
                                <label>Payment Method*</label><br />

                                {payment_method_otions}
                                <RenderErrors 
                                    errors={errors} 
                                    name="options" 
                                    className="text-danger fs-7"
                                />

                              </div>
                          </div>

                          <div className="col-12">
                              <div className="row">
                                  <div className="col-md-6 mb-3">
                                      <InputText
                                          id="registration_start_date" 
                                          name="registration_start_date" 
                                          value={event_data.registration_start_date}   
                                          label="Registration Start *"
                                          tagClass="form-control"
                                          onChange={inputChange}
                                          type="date"
                                      />
                                      <RenderErrors 
                                          errors={errors} 
                                          name="registration_start_date" 
                                          className="text-danger fs-7"
                                      />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                      <InputText
                                          id="registration_start_time" 
                                          name="registration_start_time" 
                                          value={event_data.registration_start_time}   
                                          label="Start Time *"
                                          tagClass="form-control"
                                          onChange={inputChange}
                                          type="time"
                                      />
                                      <RenderErrors 
                                          errors={errors} 
                                          name="registration_start_time" 
                                          className="text-danger fs-7"
                                      />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                      <InputText
                                          id="registration_end_date" 
                                          name="registration_end_date" 
                                          value={event_data.registration_end_date}   
                                          label="Registration End *"
                                          tagClass="form-control"
                                          onChange={inputChange}
                                          type="date"
                                      />
                                      <RenderErrors 
                                          errors={errors} 
                                          name="registration_end_date" 
                                          className="text-danger fs-7"
                                      />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                      <InputText
                                          id="registration_end_time" 
                                          name="registration_end_time" 
                                          value={event_data.registration_end_time}   
                                          label="End Time *"
                                          tagClass="form-control"
                                          onChange={inputChange}
                                          type="time"
                                      />
                                      <RenderErrors 
                                          errors={errors} 
                                          name="registration_end_time" 
                                          className="text-danger fs-7"
                                      />
                                  </div>
                              </div>
                          </div>
                      
                          <div className="col-12"><hr/></div>
                      </div>
                        <div className='row mb-3'>
                            <div className="col-12">
                                <label>Registration Form Fields*</label>
                                {customFieldTable()}
                                <RenderErrors 
                                    errors={errors} 
                                    name="fields" 
                                    className="text-danger fs-7"
                                />
                            </div>

                            <div className="col-12"><hr/></div>

                            <div className="col-12">
                                <label>Restriction Codes</label>
                                {restrictionCodesTable()}
                                <RenderErrors 
                                    errors={errors} 
                                    name="restriction_codes" 
                                    className="text-danger fs-7"
                                />
                            </div>

                            <div className="col-12"><hr/></div>

                            <div className="col-12  mb-3">
                                <InputTextArea
                                    id="email_success_msg" 
                                    name="email_success_msg" 
                                    label="Email Success Message*"
                                    value={event_data.email_success_msg}  
                                    tagClass="form-control"
                                    onChange={inputChange}
                                />
                                <RenderErrors 
                                    errors={errors} 
                                    name="email_success_msg" 
                                    className="text-danger fs-7"
                                />
                            </div>

                            <div className="col-12 mb-3">
                                <InputTextArea
                                    id="email_error_msg" 
                                    name="email_error_msg" 
                                    label="Email Error Message*"
                                    value={event_data.email_error_msg}  
                                    tagClass="form-control"
                                    onChange={inputChange}
                                />
                                <RenderErrors 
                                    errors={errors} 
                                    name="email_error_msg" 
                                    className="text-danger fs-7"
                                />
                            </div>

                            <div className="col-md-6">
                                <InputText
                                    id="motivation_code" 
                                    name="motivation_code" 
                                    value={event_data.motivation_code}   
                                    label="Motivation Code"
                                    tagClass="form-control mb-3"
                                    onChange={inputChange}
                                    type="text"
                                    placeholder='Motivation Code'
                                />
                                <RenderErrors 
                                    errors={errors} 
                                    name="motivation_code" 
                                    className="text-danger fs-7"
                                />
                            </div>
                        </div>



                        <hr/>

                        <a href="#" className="staff-back" onClick={(e)=>submit(e, 'draft')}>Save As Draft</a>
                        <button type="button" className="login-button" onClick={(e)=>submit(e,'active')}>Publish</button>
                    
                    </div>{/* container */}
                </div>
              </div>
            
        </div>
    </section>


    )
}
 
export default EventForm;